import axios from 'axios';

export const loadCareQuestDashboard = providerPracticeId => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/care-quest-dashboard`)
			.then(({ data }) => {
				resolve(data.status);
			})
			.catch(err => reject(err));
	})
);

export const loadVitalTrackerDashboard = (providerId, date_start, date_end) => (
	axios.get(`/providers/${providerId}/vital-tracker-dashboard-v2`, { params: { date_start, date_end } })
);

export const acknowledge = ({ id, providerId }) => (
	axios.put(`/care_quest_response_groups/${id}/provider-response`, { id, providerId })
);

export const reply = ({ id, ...response }) => (
	axios.put(`/care_quest_response_groups/${id}/provider-response`, { id, ...response })
);

export const acknowledgeVitalNotification = ({ providerId, vital_id }) => (
	axios.post(`/providers/${providerId}/vital-tracker-dashboard-update`, { vital_id })
);

export const replyVitalNotification = ({ providerId, vital_id, provider_response, evisit_recommended = true }) => (
	axios.post(`/providers/${providerId}/vital-tracker-dashboard-update`, { vital_id, provider_response, evisit_recommended })
);

export const loadQuestions = (care_quest_groupId) => (
	axios.get('/care_quest_questions', {
		params: {
			filter: JSON.stringify({
				where: {
					care_quest_groupId
				},
				include: 'care_quest_answers',
				order: 'question_order'
			})
		}
	})
);

export const loadResponses = (care_quest_response_groupId) => (
	axios.get(`/care_quest_response_groups/${care_quest_response_groupId}/care_quest_responses`)
);

export const loadRelatedResponses = (care_quest_groupId, patientId, currentResponseId) => (
	axios.get('/care_quest_response_groups', {
		params: {
			filter: JSON.stringify({
				where: {
					care_quest_groupId,
					patientId,
					id: { neq: currentResponseId }
				},
				include: 'care_quest_responses',
				limit: 15,
				order: 'response_dttm DESC'
			})
		}
	})
);
